import CustomToast from 'ui/CustomToast'

export const handleForbiddenError = (error, navigate) => {
  if (error.response?.status !== 403) return false

  CustomToast({
    message:
      error.response.data?.message ||
      'You are not authorized to view this document.',
    type: 'error',
  })
  navigate('/', { replace: true })
  return true
}

export const handleRequestError = (error) => {
  const env = process.env.REACT_APP_ENV || 'production' //eslint-disable-line no-undef

  if (env === 'production') return

  if (error.isErrorHandled) return
  if (error.response) {
    CustomToast({
      message: error.response.data.message
        ? error.response.data.message
        : 'Server Error!',
      type: 'error',
    })
  } else {
    CustomToast({
      message: 'Server Error!',
      type: 'error',
    })
  }
}
